import React, { useState } from "react"
import { Link } from "react-router-dom"

import Divider from "../Divider/Divider"
import Button from "../Button/Button"

import "./form.css"

import calendar from "../images/calendar.svg"
import unChecked from "../images/un-checked.svg"
import checked from "../images/checked.svg"

class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isSalmonChecked: false,
      isScallopsChecked: false,
      isLobsterChecked: false,
      isFiletChecked: false,
      isTunaChecked: false,
      isMahiChecked: false,
      isServerChecked: false,
      isCleanupChecked: false,
      isBeerChecked: false,
      isWineChecked: false,
      isSoupChecked: false,
      isSaladChecked: false,
    }

    this.isChecked = this.isChecked.bind(this)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  isChecked(e) {
    this.setState({
      [e]: !this.state[e],
    })
  }

  render() {
    return (
      <div className="form-page">
        <div className="form-page__header-container">
          <div className="form-page__bg" />
          <div className="form-page__header">
            <div className="form-page__heading">
              <img alt="Menu" className="form-page__icon" src={calendar} />
              <h1>Schedule Party</h1>
            </div>
            <div className="form-page__desktop-description">
              <div className="form-page__sub-header">
                <div className="form-page__sub-header-wrapper">
                  <h2>Grilled on Site</h2>
                  <Divider />
                  <p>
                    <span>Hibachi & You</span> will grill on site and guests
                    will serve themselves in a buffet type fashion.
                  </p>
                </div>
                <div className="form-page__sub-header-wrapper">
                  <h2>What We'll Provide</h2>
                  <Divider />
                  <p>Hibachi & You will provide tables and linens. At an additional charge, we can also provide: serving utensils, napkins, chaffing dishes, plates, and utensils.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-page__form-container">
          <div className="form-page__sub-header-mobile">
            <div className="form-page__sub-header-wrapper">
              <h2>Grilled on Site</h2>
              <Divider />
              <p>
                <span>Hibachi & You</span> will grill on site and guests
                will serve themselves in a buffet type fashion.
              </p>
            </div>
            <div className="form-page__sub-header-wrapper">
              <h2>What We'll Provide</h2>
              <Divider />
              <p>Hibachi & You will provide tables and linens. At an additional charge, we can also provide: serving utensils, napkins, chaffing dishes, plates, and utensils.</p>
            </div>
          </div>
          <div className="form-page__form-wrapper">
            <form
              method="POST"
              action="https://formspree.io/f/info@hibachiandyou.com"
              className="form-page__form"
            >
              <div className="form-page__specials-header">
                <h2>Tell Us About Your Party</h2>
                <Divider />
              </div>
              <input
                className="form-page__gotcha-input"
                type="text"
                name="_gotcha"
              />
              <div className="form-page__inputs-wrapper">
                <label htmlFor="your-name">Your Name</label>
                <input
                  className="form-page__input"
                  type="text"
                  name="Name"
                  id="your-name"
                  placeholder="What's your name?"
                  required
                />
              </div>
              <div className="form-page__inputs-wrapper">
                <label htmlFor="guests">Number of Guests</label>
                <input
                  className="form-page__input"
                  type="number"
                  name="Guests #"
                  id="guests"
                  placeholder="How many guests will eat?"
                  required
                />
              </div>
              <div className="form-page__inputs-wrapper">
                <label htmlFor="event">Event Type</label>
                <input
                  className="form-page__input"
                  type="text"
                  name="Event Type"
                  id="event"
                  placeholder="Wedding, birthday, etc."
                  required
                />
              </div>
              <div className="form-page__inputs-wrapper">
                <label htmlFor="location">Location</label>
                <input
                  className="form-page__input"
                  type="text"
                  name="Event Location"
                  id="location"
                  placeholder="E.g. Boca Raton"
                  required
                />
              </div>
              <div className="form-page__inputs-wrapper">
                <label htmlFor="phone">Phone</label>
                <input
                  className="form-page__input"
                  type="text"
                  name="Phone"
                  id="phone"
                  placeholder="(555)-555-5555"
                  required
                />
              </div>
              <div className="form-page__inputs-wrapper">
                <label htmlFor="e-mail">Your Email</label>
                <input
                  className="form-page__input"
                  type="email"
                  name="_replyto"
                  id="e-mail"
                  placeholder="Email"
                  required
                />
              </div>
              <div className="form-page__inputs-wrapper">
                <label htmlFor="date">Party Date</label>
                <input
                  className="form-page__input"
                  type="date"
                  name="Date"
                  id="date"
                  placeholder="Date"
                  required
                />
              </div>

              {/* Hidden Specials inputs */}
              <div className="form-page__hidden-specials">
                <div className="form-page__specials-scallops">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Scallops"
                    value={this.state.isScallopsChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-salmon">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Salmon"
                    readOnly
                    value={this.state.isSalmonChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-tuna">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Tuna"
                    readOnly
                    value={this.state.isTunaChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-mahi">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Mahi Mahi"
                    readOnly
                    value={this.state.isMahiChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-filet">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Filet Mignon"
                    readOnly
                    value={this.state.isFiletChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-lobster">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Lobster Tail"
                    readOnly
                    value={this.state.isLobsterChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-beer">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Beer"
                    readOnly
                    value={this.state.isBeerChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-wine">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Wine"
                    readOnly
                    value={this.state.isWineChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-server">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Server"
                    readOnly
                    value={this.state.isServerChecked === true ? "yes" : "no"}
                  />
                </div>

                <div className="form-page__specials-cleanup">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Cleanup"
                    readOnly
                    value={this.state.isCleanupChecked === true ? "yes" : "no"}
                  />
                </div>
                <div className="form-page__specials-soup">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Soup"
                    readOnly
                    value={this.state.isSoupChecked === true ? "yes" : "no"}
                  />
                </div>
                <div className="form-page__specials-salad">
                  <input
                    className="form-page__input"
                    type="text"
                    name="Salad"
                    readOnly
                    value={this.state.isSaladChecked === true ? "yes" : "no"}
                  />
                </div>
              </div>
              <label className="form-page__specials-label">
                What sides would you like
              </label>
              <div className="form-page__sub-text">Sides are optional</div>
              <div className="form-page__specials-wrapper">
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isSoupChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isSoupChecked")}
                  role="button"
                  >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isSoupChecked ? checked : unChecked}
                  />
                  Soup
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isSaladChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isSaladChecked")}
                  role="button"
                  >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isSaladChecked ? checked : unChecked}
                  />
                  Salad
                </div>
              </div>
              <label className="form-page__specials-label">
                Choose your specials
              </label>
              <div className="form-page__sub-text">
                Each special is charged per person
              </div>
              <div className="form-page__specials-wrapper">
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isScallopsChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isScallopsChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isScallopsChecked ? checked : unChecked}
                  />
                  Scallops
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isSalmonChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isSalmonChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isSalmonChecked ? checked : unChecked}
                  />
                  Salmon
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isFiletChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isFiletChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isFiletChecked ? checked : unChecked}
                  />
                  Filet Mignon
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isTunaChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isTunaChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isTunaChecked ? checked : unChecked}
                  />
                  Tuna
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isLobsterChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isLobsterChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isLobsterChecked ? checked : unChecked}
                  />
                  Lobster
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isMahiChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isMahiChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isMahiChecked ? checked : unChecked}
                  />
                  Mahi Mahi
                </div>
              </div>
              <label className="form-page__specials-label">Beverages</label>
              <div className="form-page__sub-text">Charged per person.</div>
              <div className="form-page__specials-wrapper">
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isBeerChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isBeerChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isBeerChecked ? checked : unChecked}
                  />
                  Beer
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isWineChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isWineChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isWineChecked ? checked : unChecked}
                  />
                  Wine
                </div>
              </div>
              <label className="form-page__specials-label">
                Additional services
              </label>
              <div className="form-page__sub-text">
                Choose whether you need a server for your party and/or after
                party clean up.
              </div>
              <div className="form-page__specials-wrapper">
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isServerChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isServerChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isServerChecked ? checked : unChecked}
                  />
                  Server
                </div>
                <div
                  className="form-page__check-box-wrapper"
                  style={
                    this.state.isCleanupChecked
                      ? { background: "#de8154", color: "#e8dad3" }
                      : { background: "white", color: "#3f3f3f" }
                  }
                  onClick={() => this.isChecked("isCleanupChecked")}
                  role="button"
                >
                  <img
                    alt="checkbox"
                    className="form-page__check-box"
                    src={this.state.isCleanupChecked ? checked : unChecked}
                  />
                  Party Clean Up
                </div>
              </div>
              <div className="form-page__submit-button-wrapper">
                <input
                  className="form-page__submit-button"
                  type="submit"
                  value="Send"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/form/form.js